import { computed, onMounted } from '@nuxtjs/composition-api';

import { useCurrency } from '~/composables/useCurrency';

export const useTopBar = () => {
  const { currency, load } = useCurrency();
  const hasCurrencyToSelect = computed(() => (currency.value?.available_currency_codes?.length ?? 0) > 1);

  onMounted(async () => {
    // Shares the same scoped metadata read as CurrencySelector/SelectWebsitePop.
    await load();
  });

  return {
    hasStoresToSelect: true,
    hasCurrencyToSelect,
  };
};

export default useTopBar;
